import { Box } from "@mantine/core";

/** Small round colour swatch used next to a model's colour label. */
export default function ColorDot({ color, size = 12 }: { color: string; size?: number }) {
  return (
    <Box
      w={size}
      h={size}
      style={{
        borderRadius: "50%",
        background: color,
        border: "1px solid var(--mantine-color-default-border)",
        flexShrink: 0,
      }}
    />
  );
}
